import Vue from "vue";
import Vuex from "Vuex";

Vue.use(Vuex);

let state = {
	cnt: 0,        // 存储答对题的次数
	name: "",      // 存储昵称
},
initialState = JSON.parse(JSON.stringify(state));     // clone state

function storeLocal (key, value) {
	/*
		存储到localStorage中
		@key: 键
		@value：值
	*/
	let info = localStorage.getItem("info"); 
	if(!info) {
		localStorage.setItem("info", "{}");
	}

	let infoObj = JSON.parse(localStorage.getItem("info"));
	infoObj[key] = value;
	localStorage.setItem("info", JSON.stringify(infoObj));
}

export default new Vuex.Store({
	state,
	mutations: {
		increment (state) {
			// 增加一次答对题的次数
			++state.cnt;
			storeLocal("cnt", state.cnt)
			return state.cnt;
		},
		setName(state, name) {
			// 设置昵称
			storeLocal("name", name);
			state.name = name;
		},
		reset (state) {
			// 重置state的状态
			let info = localStorage.getItem("info");
			if(info) {
				info = JSON.parse(info);
				if(info.cnt) {
					info.cnt = 0;
				}
				localStorage.setItem("info", JSON.stringify(info));
			}
			state = initialState;
		}
	}
});


// WEBPACK FOOTER //
// ./src/store/store.js